import index from '../components/index'
import create from '../components/create'
import edit from '../components/_id/edit'


export default [
    {
        path: '/tickets',
        component: index,
        name: 'tickets',
        meta: { auth: true },
    },
    {
        path: '/tickets/create',
        component: create,
        name: 'tickets.create',
        meta: { auth: true },
    },
    {
        path: '/tickets/:id/edit',
        component: edit,
        name: 'tickets.edit',
        props: { default: true },
        meta: { auth: true },
    },
]